module.exports = __webpack_public_path__ + "img/defaultprofileimage.69831df2.jpg";